import React from "react";

import { Outer, Inner } from "./KgNodeFrame.styles";
import type { KgNodeFrameProps } from "./KgNodeFrame.types";

export const KgNodeFrame: React.FC<KgNodeFrameProps> = ({
  category,
  visualState = "default",
  isSelected = false,
  flush = false,
  figmaNodeId,
  className,
  onClick,
  children,
}) => (
  <Outer
    $category={category}
    $visualState={visualState}
    $isSelected={isSelected}
    $clickable={Boolean(onClick)}
    className={className}
    data-figma-node-id={figmaNodeId}
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onClick(event);
            }
          }
        : undefined
    }
  >
    <Inner $flush={flush} $category={category}>
      {children}
    </Inner>
  </Outer>
);

export default KgNodeFrame;
